import { MentionNodeDataProvider } from '@atlaskit/editor-plugin-mentions/mention-node-data-provider';

type MentionAvatarData = {
	avatarUrl: string;
	isAvatarImagePreShaped: boolean;
};

const resolveMentionNodeData = ({ id: accountId }: { id: string }): MentionAvatarData => ({
	avatarUrl: `/wiki/aa-avatar/${encodeURIComponent(accountId)}`,
	isAvatarImagePreShaped: true,
});

/** Creates a page-scoped provider backed by Confluence's deterministic avatar route. */
export const createMentionNodeDataProvider = (): MentionNodeDataProvider =>
	new MentionNodeDataProvider(() => Promise.resolve({}), resolveMentionNodeData);
